import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["dialog"]

  get modalElement() {
    // Use dialog target if available, otherwise fall back to this.element
    return this.hasDialogTarget ? this.dialogTarget : this.element
  }

  connect() {
    // Only prevent body scroll if modal is not hidden
    if (!this.modalElement.classList.contains("hidden")) {
      document.body.classList.add("overflow-hidden")
    }
  }

  disconnect() {
    // Restore body scroll
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event?.preventDefault()

    // Generic form action handling: if the trigger has a data-form-action attribute,
    // apply it to any form inside this modal
    const formAction = event.currentTarget?.dataset.formAction
    if (formAction) {
      const form = this.modalElement.querySelector("form")
      if (form) {
        form.action = formAction
      }
    }

    // Show the modal
    this.modalElement.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    event?.preventDefault()

    // If this is a turbo frame, clear it to close the modal
    if (this.modalElement.tagName === "TURBO-FRAME") {
      this.modalElement.innerHTML = ""
    } else {
      // Otherwise just hide it
      this.modalElement.classList.add("hidden")
    }

    document.body.classList.remove("overflow-hidden")
  }

  // Close on background click
  closeBackground(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  // Close on escape key
  closeWithKeyboard(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }
}
